import {MobileMainMenuComponent} from './mobile-main-menu/mobile-main-menu.component';
import {MobileNewRequestComponent} from './mobile-new-request/mobile-new-request.component';
import {MobileOfferComponent} from './mobile-offer/mobile-offer.component';
import {NotFoundComponent} from '../not-found/not-found.component';
import {NewRequestConfirmationComponent} from './new-request-confirmation/new-request-confirmation.component';
import {Routes} from '@angular/router';
import {MobileRequestInfoComponent} from './mobile-request-info/mobile-request-info.component';
import {RoleGuard} from '../../services/guards/role-guard.service';
import {MobileTokenPageComponent} from './mobile-token-page/mobile-token-page.component';
import {MobileGuestStatusComponent} from './mobile-guest-status/mobile-guest-status.component';

export const routes: Routes = [
  {
    path: 'mobile',
    children: [
      {
        path: '',
        component: MobileMainMenuComponent
      },
      {
        path: 'home',
        component: MobileMainMenuComponent
      },
      {
        path: 'basic-information',
        component: MobileNewRequestComponent
      },
      {
        path: 'offers',
        component: MobileOfferComponent
      },
      {
        path: 'details',
        component: MobileRequestInfoComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: 'confirmation',
        component: NewRequestConfirmationComponent
      },
      {
        path: 'guest',
        component: MobileTokenPageComponent
      },
      {
        component: MobileGuestStatusComponent,
        path: 'guest/:mobile/:requestToken'
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
